import styled, { css } from 'styled-components'

export const Wrapper = styled.div(({ theme: { palette } }) => css`
  display: flex;
  flex-direction: column;
  padding: 1.25rem 1.5rem;
  background-color: ${palette.light.white};
`)

interface TableSpanProps {
  $bold?: boolean
  $left?: boolean
}

export const TableSpan = styled.span<TableSpanProps>(({
  theme: { typography },
  $bold,
  $left,
}) => css`
  display: flex !important;
  align-items: center;
  font-size: ${typography.small.pt_13_regular.fontSize};
  font-weight: ${$bold ? typography.small.pt_13_semibold.fontWeight : typography.small.pt_13_regular.fontWeight};
  line-height: ${typography.small.pt_13_regular.lineHeight};
  white-space: wrap !important;
  justify-content: ${$left ? 'flex-start' : 'flex-end'};
`)

export const Description = styled.span(({
  theme: {
    typography, palette,
  },
}) => css`
  font-size: ${typography.small.pt_13_regular.fontSize};
  font-weight: ${typography.small.pt_13_regular.fontWeight};
  line-height: ${typography.small.pt_13_regular.lineHeight};
  color: ${palette.dark.normal};
`)

export const SimilarAdressWrapper = styled.ul(({ theme: { palette } }) => css`
  width: 100%;
  list-style-type: none;

  >li:nth-child(2n){
  background-color: ${palette.light.main};
  }
`)

interface TitleProps {
  $borderTop?: boolean
}

export const Title = styled.h4<TitleProps>(({
  theme: {
    palette,
    typography,
  },
  $borderTop,
}) => css`
  font-weight: 500;
  font-size: ${typography.main.pt_15_semibold.fontSize};
  line-height: ${typography.main.pt_15_semibold.lineHeight};
  letter-spacing: ${typography.main.pt_15_semibold.letterSpacing};
  text-transform: ${typography.main.pt_15_semibold_upper.textTransform};
  color: ${palette.black};
  margin-bottom: 0.5rem;
  ${$borderTop && css`
    border-top: 1px solid ${palette.light.darker};
    padding-top: 1.5rem;
  `}
`)
